import { render, staticRenderFns } from "./summary-product.vue?vue&type=template&id=0c1d9001&scoped=true"
import script from "./summary-product.vue?vue&type=script&lang=ts"
export * from "./summary-product.vue?vue&type=script&lang=ts"
import style0 from "./summary-product.vue?vue&type=style&index=0&id=0c1d9001&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1d9001",
  null
  
)

export default component.exports